import React from "react";

export const Extensions = () => {
    return (
        <React.Fragment>
            <h1>Extensions</h1>
            <p>We werken met extensions van het merk Socap.</p>
        </React.Fragment>
    );
}